import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import url from '../constants/urlsPaths';
import Axios from 'axios';
import './CompanyManager.css';

export default function CompanyManager() {
    const [company, setCompany] = useState({});
    const [companies, setCompanies] = useState([]);
    const [users, setUsers] = useState([]);
    const [/*loading,*/ setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [showAdminDropdown, setShowAdminDropdown] = useState(false);
    const [allAdmins, setAllAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState("");
    const [pendingAdmins, setPendingAdmins] = useState([]);
    const [expandedCompanies, setExpandedCompanies] = useState({});
    const [adminsByCompany, setAdminsByCompany] = useState({});
    const [usersByCompany, setUsersByCompany] = useState({}); // store full users list per company for stats
    const [loadingAdmins, setLoadingAdmins] = useState({});
    const [companyFilter, setCompanyFilter] = useState('all');
    const [adminFilter, setAdminFilter] = useState('all');

    useEffect(() => {
        Axios.post(url.getCompanies, { code: sessionStorage.getItem("code") },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            if (res.data.auth === false) {
                sessionStorage.clear();
                window.location.reload()
            } else {
                setCompanies(res.data);
            }
        })
        .catch(err => {
            console.log(err)
        })
    }, [])

    // fetch all admins once to populate admin filter dropdown
    useEffect(() => {
        fetchAllAdmins();
    }, []);

    const fetchAllAdmins = () => {
        Axios.post(url.allUsers, { code: sessionStorage.getItem("code") }, {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            if (res.data.auth === false) {
                sessionStorage.clear();
                window.location.reload();
            } else {
                // Only admins
                setAllAdmins(res.data.users.filter(u => u.authorities === "admin"));
            }
        })
        .catch(err => {
            console.log(err)
        });
    };

    const currentCompanyAdminIds = users
        .filter(u => u.authorities === "admin" && Array.isArray(u.company) && u.company.includes(company._id))
        .map(u => u._id);

    const availableAdmins = allAdmins.filter(a => !currentCompanyAdminIds.includes(a._id));

    const handleAddAdminClick = () => {
        fetchAllAdmins();
        setShowAdminDropdown(true);
    };

    const getUsersByCompanyWithCsv = (companyID) => {
        //get filtered list of users
        console.log("GET getUsersByCompanyWithCsv",companyID);
        Axios.post(url.allUsers, { code: sessionStorage.getItem("code"), company: companyID },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            downloadUsersCSV();
            if (res.data.auth === false) {
                sessionStorage.clear();
                window.location.reload();
            }
            else {
                const reordered = res.data.users.sort((a,b) => a.code - b.code);
                setUsers(reordered);
                setTimeout(() => {
                    setLoading(false);
                }, 2000);

                //si super admin 
                if(res.data.isSuperAdmin){
                    // get all companies
                    Axios.post(url.getCompanies, { code: sessionStorage.getItem("code") },
                    {
                        headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
                    })
                    .then(res => {
                        setCompanies(res.data);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }
            }
        })
        .catch(err => {
            console.log(err)
        })
    }

        const getUsersByCompany = (companyID) => {
        //get filtered list of users
        console.log("GET getUsersByCompany",companyID);
        Axios.post(url.allUsers, { code: sessionStorage.getItem("code"), company: companyID },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            if (res.data.auth === false) {
                sessionStorage.clear();
                window.location.reload();
            }
            else {
                setUsers(res.data.users);
            }
        })
        .catch(err => {
            console.log(err)
        })
    }

    const handleChange = (e) => {
        const newCompany = { ...company }
        newCompany[e.target.name] = e.target.value
        setCompany(newCompany);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    // prepare aliases payload: accept comma-separated string in the UI
    const aliasesPayload = (() => {
        if (!company.aliases) return [];
        if (Array.isArray(company.aliases)) return company.aliases;
        return company.aliases.split(',').map(a => a.trim()).filter(a => a.length > 0);
    })();

    Axios.post(url.addCompany, {name : company.name, logoUrl: company.logo || '', aliases: aliasesPayload, code: sessionStorage.getItem("code") },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            const newCompanies = [...companies];
            newCompanies.push(res.data.company);
            alert('company added !');
            setShowModal(false);
            setCompany({});
            setCompanies(newCompanies)

        })
        .catch(err => {
            console.log(err)
        })
    }
    const downloadUsersCSV = () => {
        const softskillsIDs = ["Ext", "Exc", "Imp", "Pes", "Sas", "Dom", "Agg", "Con", "Cap", "Scm", "Pro", "Emo", "Sem", "Rum", "Iat", "Sss", "Wis", "Scb", "Exp", "Are", "Str", "Neg", "Irr", "Ser", "Anx", "Sco", "Enj", "Lea", "Sec", "Ist", "Sal", "Tas", "Pow", "Suc", "Mor", "Int", "Aff", "Har"];
        let text = "";
        text += "Code; Survey passed; Date passed; Company; Language; Type";
        //Voir si au moins un user à passé le test pour mettre les titres
        if (users.find(el => el.testPassed === true)) {
            softskillsIDs.forEach(soft => {
                text += ";" + soft;
            })
        }
        else {
            console.log('No one has passed the test')
        }

        text += "\r";
        for (let i = 0; i < users.length; i++) {
            text += (users[i].code) + ";";
            text += (users[i].testPassed) + ";";
            text += (users[i].dateSurveyPassed) + ";";
            text += "skillspotting;";
            text += (users[i].language) + ";";
            if (users[i].testPassed === true) {
                text += (users[i].answers[101]["POSTE"] + users[i].answers[97]["SEXE"]);
            }
            else {
                text += "No data yet";
            }


            if (users[i].testPassed === false) {
                for (let k = 0; k < users[i].results.length; k++) {
                    text += "noData; ";
                }
            }
            else {
                console.log("results",users[i].results.length);
                for (let k = 0; k < users[i].results.length; k++) {
                    for (let z = 0; z < users[i].results[k].data.length; z++) {
                        let data = users[i].results[k].data[z].user;
                        text += ";" + data;
                    }
                }
                text += ";ANSWERS";
                for (let k = 0; k < users[i].answers.length; k++) {
                    let data = users[i].answers[k];
                        var theseKeys = Object.keys(data);
                        var theseValues = Object.values(data);
                        for(let k1 = 0; k1 < Object.keys(data).length; k1++){
                        text += ";" + theseKeys[k1]+";"+theseValues[k1];
                        }
                }
                console.log("answers",users[i].answers.length);
            }
            text += "\r";
        }
        let txtContent = "data:text/csv;charset=utf-8," + encodeURIComponent(text);
        let anchor = document.createElement('a');
        anchor.href = "data:" + txtContent;
        anchor.target = '_blank';
        anchor.download = "allUsersResponsesAndResults.csv";
        anchor.click();
    }

    const addCompany = () => {
        setCompany({ name: '', logo: '', aliases: '' });
        setShowModal(true);
        setEditMode(false);
    }

    const handleSubmitEdit = (e) => {
        e.preventDefault();

    // prepare aliases payload: accept comma-separated string in the UI
    const aliasesPayload = (() => {
        if (!company.aliases) return [];
        if (Array.isArray(company.aliases)) return company.aliases;
        return company.aliases.split(',').map(a => a.trim()).filter(a => a.length > 0);
    })();

    Axios.post(url.editCompany, {idCompany : company._id, nameCompany : company.name, logoUrl: company.logo || '', aliases: aliasesPayload, code: sessionStorage.getItem("code") },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            const newCompanies = [...companies];
            const found = newCompanies.find(el => el._id === res.data.company._id);
            if (found) {
                found.name = res.data.company.name;
                found.logo = res.data.company.logo || found.logo;
            }
            alert('company edited !');
            setShowModal(false);
            setCompany({});
            setCompanies(newCompanies)

        })
        .catch(err => {
            console.log(err)
        })

        setShowModal(false);
        setCompany({});
    }

    const editCompany = (company) => {
        // ensure aliases field is a comma-separated string for editing
        const aliasesString = Array.isArray(company.aliases) ? company.aliases.join(', ') : (company.aliases || '');
        setCompany({ ...company, aliases: aliasesString });
        setShowModal(true);
        setEditMode(true);
        getUsersByCompany(company._id); // <-- fetch users for this company
    }

    const companyUserList = (company) => {
        console.log("companyUserList",company._id);
        getUsersByCompanyWithCsv(company._id);
    }
    const closeModal = () => {
        setCompany({});
        setShowModal(false);
        setEditMode(false);
    }

    return (
        <div id="CompanyManager">
            <div id="CompanyManager-header">
                <Link to='/manager' className="CompanyManager-back-btn">Back to manager</Link>
                <h2>Companies</h2>
            </div>
            <div id="CompanyManager-content">

                {/* Filters: company and admin */}
                <div style={{ marginBottom: 12, padding: '8px', border: '1px solid #eee', borderRadius: 6, background: '#fafafa' }}>
                    <div style={{ marginBottom: 6, fontWeight: 700 }}>Filters</div>
                    <div style={{ marginBottom: 8, color: '#666' }}>Use these controls to limit the company list. Expand a company to load its users if the admin list is empty.</div>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        <div>
                            <label style={{ marginRight: 8 }}>Company:</label>
                            <select value={companyFilter} onChange={e => setCompanyFilter(e.target.value)}>
                                <option value="all">All companies</option>
                                {companies.map(c => (
                                    <option key={c._id} value={c._id}>{c.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label style={{ marginRight: 8 }}>Admin:</label>
                            <select value={adminFilter} onChange={e => setAdminFilter(e.target.value)} disabled={!allAdmins || allAdmins.length === 0}>
                                <option value="all">All admins</option>
                                {allAdmins && allAdmins.map(a => (
                                    <option key={a._id} value={a._id}>{a.email || a.code}</option>
                                ))}
                            </select>
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <button className="CompanyManager-action-btn" onClick={() => { setCompanyFilter('all'); setAdminFilter('all'); }}>Clear</button>
                            <button className="CompanyManager-action-btn" onClick={() => fetchAllAdmins()}>Reload admins</button>
                        </div>
                    </div>
                    {(!allAdmins || allAdmins.length === 0) && (
                        <div style={{ marginTop: 8, color: '#a00' }}>Admin list is empty. Expand a company row to load users or click "Reload admins".</div>
                    )}
                </div>

                <table id="CompanyManager-table">
                    <thead>
                        <tr>
                            <th className="CompanyManager-id-th" scope="col" style={{ fontSize: '15px' }}>#</th>
                            <th scope="col">Name</th>
{/*                             <th scope="col">Color theme</th> */}
                            <th scope="col">
                                <button className="CompanyManager-action-btn" onClick={() => addCompany()}>New</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            companies.map((company, index) => {
                                // Apply company filter: only render matching company when filter is set
                                if (companyFilter !== 'all' && company._id !== companyFilter) return null;
                                const toggleAdmins = async (e) => {
                                    // if called from a button, don't toggle (buttons stopPropagation already)
                                    // toggle open/close for this company
                                    const id = company._id || index;
                                    const isOpen = !!expandedCompanies[id];
                                    if (isOpen) {
                                        setExpandedCompanies(prev => ({ ...prev, [id]: false }));
                                        return;
                                    }

                                    // if we already loaded admins for this company, just open
                                    if (adminsByCompany[id]) {
                                        setExpandedCompanies(prev => ({ ...prev, [id]: true }));
                                        return;
                                    }

                                    // set loading
                                    setLoadingAdmins(prev => ({ ...prev, [id]: true }));

                                    // fetch users for this company and keep only admins
                                    try {
                                        const res = await Axios.post(url.allUsers, { code: sessionStorage.getItem("code"), company: company._id }, {
                                            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
                                        });
                                        if (res.data && res.data.users) {
                                            // store full users for this company for stats
                                            setUsersByCompany(prev => ({ ...prev, [id]: res.data.users }));
                                            // keep only admins that belong to this company
                                            const admins = res.data.users.filter(u => {
                                                const isAdmin = u.authorities === 'admin';
                                                const inCompany = Array.isArray(u.company) ? u.company.includes(company._id) : (u.company === company._id);
                                                return isAdmin && inCompany;
                                            });
                                            setAdminsByCompany(prev => ({ ...prev, [id]: admins }));
                                            setExpandedCompanies(prev => ({ ...prev, [id]: true }));
                                            setLoadingAdmins(prev => ({ ...prev, [id]: false }));
                                        } else {
                                            setUsersByCompany(prev => ({ ...prev, [id]: [] }));
                                            setAdminsByCompany(prev => ({ ...prev, [id]: [] }));
                                            setExpandedCompanies(prev => ({ ...prev, [id]: true }));
                                            setLoadingAdmins(prev => ({ ...prev, [id]: false }));
                                        }
                                    } catch (err) {
                                        console.log('Failed to fetch admins for company', company._id, err);
                                        setAdminsByCompany(prev => ({ ...prev, [id]: [] }));
                                        setExpandedCompanies(prev => ({ ...prev, [id]: true }));
                                        setLoadingAdmins(prev => ({ ...prev, [id]: false }));
                                    }
                                };

                                const idKey = company._id || index;

                                // Apply admin filter: if set and we already have users for this company, skip if admin not present
                                if (adminFilter !== 'all' && usersByCompany[idKey] && Array.isArray(usersByCompany[idKey])) {
                                    const adminPresent = usersByCompany[idKey].some(u => u._id === adminFilter);
                                    if (!adminPresent) return null;
                                }

                                return ([
                                    <tr key={`row-${idKey}`} onClick={toggleAdmins} style={{ cursor: 'pointer' }}>
                                        <td className="CompanyManager-id-td">{index}</td>
                                        <td style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            {company?.logo ? <img src={company.logo} alt="logo" style={{ width: 48, height: 24, objectFit: 'contain', border: '1px solid #eee' }} /> : null}
                                            <span>{company?.name}</span>
                                        </td>
                                        {/*<td>{company.colorTheme}</td> */}
                                        <td>
                                            <button className="CompanyManager-action-btn" onClick={(e) => { e.stopPropagation(); editCompany(company); }}>Edit</button>
                                            <button className="CompanyManager-action-btn btn-margin" onClick={(e) => { e.stopPropagation(); companyUserList(company); }}>Data</button>
                                        </td>
                                    </tr>,
                                    expandedCompanies[idKey] ? (
                                        <tr className="CompanyManager-admin-row" key={`admins-${idKey}`}>
                                            <td colSpan={3} style={{ background: '#f9f9f9', padding: '8px 16px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <strong>Admins:</strong>
                                                        <div style={{ marginTop: 6 }}>
                                                            {loadingAdmins[idKey] ? (
                                                                <div>Loading admins...</div>
                                                            ) : usersByCompany[idKey] && usersByCompany[idKey].length > 0 ? (
                                                                // show only admins in the list but usersByCompany contains the full list used for stats
                                                                adminsByCompany[idKey] && adminsByCompany[idKey].length > 0 ? (
                                                                    adminsByCompany[idKey].map(admin => (
                                                                        <div key={admin._id} style={{ padding: '4px 0' }}>- {admin.email || admin.code}</div>
                                                                    ))
                                                                ) : (
                                                                    <div style={{ padding: '4px 0' }}>No admins for this company.</div>
                                                                )
                                                            ) : (
                                                                <div style={{ padding: '4px 0' }}>No users for this company.</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ minWidth: 220, marginLeft: 20 }}>
                                                        <strong>Stats</strong>
                                                        <div style={{ marginTop: 6 }}>
                                                            {/* Compute stats from fetched users (res.data.users) if available otherwise fetch summary */}
                                                            {(() => {
                                                                const allUsers = usersByCompany[idKey] || null;
                                                                if (!allUsers) {
                                                                    return (
                                                                        <div>
                                                                            <div>Total licences/users: N/A</div>
                                                                            <div>Total with user status: N/A</div>
                                                                            <div>Total with promo status: N/A</div>
                                                                            <div>Total without admin: N/A</div>
                                                                            <div>Total admin: {adminsByCompany[idKey] ? adminsByCompany[idKey].length : 0}</div>
                                                                        </div>
                                                                    )
                                                                }

                                                                // Defensive: filter allUsers to those that belong to this company (server may return all users)
                                                                const companyUsers = allUsers.filter(u => {
                                                                    try {
                                                                        if (Array.isArray(u.company)) return u.company.includes(company._id);
                                                                        return u.company === company._id;
                                                                    } catch (e) {
                                                                        return false;
                                                                    }
                                                                });

                                                                // Compute stats A-E from companyUsers
                                                                const totalUsers = companyUsers.length;
                                                                const totalUserStatus = companyUsers.filter(u => String(u.authorities) === 'user').length;
                                                                const totalPromoStatus = companyUsers.filter(u => String(u.authorities) === 'promo').length;
                                                                const totalAdmin = companyUsers.filter(u => String(u.authorities) === 'admin').length;
                                                                const totalWithoutAdmin = companyUsers.filter(u => String(u.authorities) !== 'admin').length;

                                                                // New: completion stats
                                                                // Assuming `testPassed` is boolean true when completed
                                                                const usersCompleted = companyUsers.filter(u => u.testPassed === true).length;
                                                                const usersNotCompleted = companyUsers.filter(u => u.testPassed !== true).length;
                                                                // Promos: users with authorities === 'promo'
                                                                const promoUsers = companyUsers.filter(u => String(u.authorities) === 'promo');
                                                                const promosCompleted = promoUsers.filter(u => u.testPassed === true).length;
                                                                const promosNotCompleted = promoUsers.filter(u => u.testPassed !== true).length;

                                                                return (
                                                                    <div>
                                                                        <div>Total licences/users: {totalUsers}</div>
                                                                        <div>Total with user status: {totalUserStatus}</div>
                                                                        <div>Total with promo status: {totalPromoStatus}</div>
                                                                        <div>Total without admin: {totalWithoutAdmin}</div>
                                                                        <div>Total admin: {totalAdmin}</div>
                                                                        <hr />
                                                                        <div>Total users completed: {usersCompleted}</div>
                                                                        <div>Total users not completed: {usersNotCompleted}</div>
                                                                        <div>Total promos completed: {promosCompleted}</div>
                                                                        <div>Total promos not completed: {promosNotCompleted}</div>
                                                                    </div>
                                                                )
                                                            })()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null
                                ])
                            })
                        }
                    </tbody>
                </table>

            </div>

            {
                showModal && 
                    <div className='CompanyManager-modal'>
                        <div className='modal-content'>
                            <div className='modal-header'>
                                <h2>{editMode ? 'Edit company' : 'Add company'}</h2>
                                <span className="modal-close-btn" onClick={() => closeModal()}>x</span>
                            </div>
                            <form className='CompanyManager-form' onSubmit={editMode ? handleSubmitEdit : handleSubmit}>
                                <label><p>Name:</p><input type='text' name='name' value={company.name || ''} onChange={handleChange} required /></label>
                                <label style={{ marginTop: 8 }}><p>Logo URL (or paste image data URL):</p>
                                    <input type='text' name='logo' value={company.logo || ''} onChange={handleChange} placeholder='https://example.com/logo.png' />
                                </label>
                                <label style={{ marginTop: 8 }}><p>Alias(s) (comma-separated):</p>
                                    <input type='text' name='aliases' value={company.aliases || ''} onChange={handleChange} placeholder='alias1, alias2' />
                                </label>
                                <label style={{ marginTop: 8 }}><p>Or upload image file (PNG/JPG):</p>
                                    <input type='file' accept="image/*" onChange={async (e) => {
                                        const f = e.target.files && e.target.files[0];
                                        if (!f) return;
                                        const reader = new FileReader();
                                        reader.onload = () => {
                                            const dataUrl = reader.result;
                                            setCompany(prev => ({ ...prev, logo: dataUrl }));
                                        };
                                        reader.readAsDataURL(f);
                                    }} />
                                </label>
                                {company.logo && (
                                    <div style={{ marginTop: 8 }}>
                                        <p>Preview:</p>
                                        <img src={company.logo} alt="company logo" style={{ maxWidth: 200, maxHeight: 80, border: '1px solid #ddd' }} />
                                    </div>
                                )}
                                <div className="CompanyManager-admin-list">
                                    {/* List of admin users for selected company */}
                                    {users.filter(u => u.authorities === "admin").length > 0 && (
                                        <div>
                                        <p>Admins:</p>
                                        <div>
                                            {/* Already assigned admins */}
                                            {users.filter(u => u.authorities === "admin" && Array.isArray(u.company) && u.company.includes(company._id)).map((user, idx) => (
                                                <div key={user._id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                    <span>- {user.email || "No email"}</span>
                                                    <button
                                                        type="button"
                                                        onClick={async () => {
                                                            // Remove company from user's company array
                                                            let updatedCompanies = Array.isArray(user.company)
                                                                ? user.company.filter(c => c !== company._id)
                                                                : [];
                                                            
                                                            // Filter out any null/undefined values before sending
                                                            await Axios.post(url.updateUser, {
                                                                id: user._id,
                                                                company: Array.isArray(updatedCompanies) ? updatedCompanies.filter(c => c != null) : []
                                                            }, {
                                                                headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
                                                            });
                                                            
                                                            // Refresh users for this company
                                                            getUsersByCompany(company._id);
                                                        }}
                                                        style={{
                                                            background: '#dc3545',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '3px',
                                                            padding: '2px 6px',
                                                            fontSize: '11px',
                                                            cursor: 'pointer',
                                                            marginLeft: '8px'
                                                        }}
                                                        title="Remove admin from company"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                            {/* Pending admins */}
                                            {pendingAdmins.map((admin, idx) => (
                                                <div key={admin._id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                    <span style={{ color: "#FFA500" }}>- {admin.email || admin.code} <span>(pending)</span></span>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            // Remove from pending list
                                                            setPendingAdmins(pendingAdmins.filter(a => a._id !== admin._id));
                                                        }}
                                                        style={{
                                                            background: '#6c757d',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '3px',
                                                            padding: '2px 6px',
                                                            fontSize: '11px',
                                                            cursor: 'pointer',
                                                            marginLeft: '8px'
                                                        }}
                                                        title="Remove from pending"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    )}
                                    
                                </div>
                                <div className='CompanyManager-submit'>
                                    <button type='submit'>{editMode ? 'Update Company' : 'Create Company'}</button>
                                    <button type='button' onClick={handleAddAdminClick}>+ Add Admin</button>
                                    {showAdminDropdown && (
                                        <div>
                                            <select
                                                className="CompanyManager-admin-dropdown"
                                                value={selectedAdmin}
                                                onChange={e => {
                                                    setSelectedAdmin(e.target.value);
                                                    // Add to pending list if not already present
                                                    const adminObj = availableAdmins.find(a => a._id === e.target.value);
                                                    if (adminObj && !pendingAdmins.some(a => a._id === adminObj._id)) {
                                                        setPendingAdmins([...pendingAdmins, adminObj]);
                                                    }
                                                }}
                                            >
                                                <option value="">Select admin to add</option>
                                                {availableAdmins.map(admin => (
                                                    <option key={admin._id} value={admin._id}>
                                                        {admin.email || admin.code}
                                                    </option>
                                                ))}
                                            </select>
                                            <button
                                                type="button"
                                                disabled={pendingAdmins.length === 0}
                                                onClick={async () => {
                                                    // Send all pending admins to backend
                                                    for (const admin of pendingAdmins) {
                                                        // Ensure company is an array and append if not present
                                                        let updatedCompanies = Array.isArray(admin.company)
                                                            ? [...admin.company]
                                                            : admin.company
                                                                ? [admin.company]
                                                                : [];
                                                        if (!updatedCompanies.includes(company._id)) {
                                                            updatedCompanies.push(company._id);
                                                        }
                                                        // Filter out any null/undefined values before sending
                                                        await Axios.post(url.updateUser, {
                                                            id: admin._id,
                                                            company: Array.isArray(updatedCompanies) ? updatedCompanies.filter(c => c != null) : []
                                                        }, {
                                                            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
                                                        });
                                                    }
                                                    // Refresh users for this company
                                                    getUsersByCompany(company._id);
                                                    setShowAdminDropdown(false);
                                                    setSelectedAdmin("");
                                                    setPendingAdmins([]);
                                                }}
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
            }

        </div>
    )
}
